export default "__VITE_ASSET__B47vgS_k__"